import React from 'react';
import { Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A1628] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row items-center gap-6 mx-auto md:mx-0">
            <a 
              href="tel:1-800-927-8327" 
              className="flex items-center gap-2 text-white hover:text-[#00A86B] transition-colors"
            >
              <Phone className="w-5 h-5" />
              <span className="font-semibold">1-800-WASTEBRO</span>
            </a>
            <a 
              href="mailto:fund@wasteloanbros.com" 
              className="flex items-center gap-2 text-white hover:text-[#00A86B] transition-colors"
            >
              <Mail className="w-5 h-5" />
              <span className="font-semibold">fund@wasteloanbros.com</span>
            </a>
          </div>

          {/* Copyright */}
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Waste Loan Bros. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
